import React from "react";

import {Route} from "react-router-dom";
import HomeScreenA7 from "./HomeScreen/index";
import ExploreScreen from "./ExploreScreen/ExploreScreen";
import who from "../reducers/who"
import {combineReducers, createStore} from "redux";
import {Provider} from "react-redux";
import tweets from "../reducers/tweets";
import profile from "../reducers/profile";
import EditProfileA7 from "../Challenge/EditProfile";
import ProfileScreenA7 from "../Challenge/ProfileScreen";

const store = createStore(combineReducers({tweets, who, profile}));

const Build = () => {
  return(
      <Provider store={store}>
        <div>
          <Route path={["/a7/twitter", "/a7/twitter/home"]}
               exact={true} component={HomeScreenA7}/>
          <Route path="/a7/twitter/explore"
               exact={true} component={ExploreScreen}/>
          <Route path="/a7/twitter/profile"
                 exact={true} component={ProfileScreenA7}/>
          <Route path="/a7/twitter/edit_profile"
                 exact={true} component={EditProfileA7}/>
        </div>
      </Provider>
  );
};
export default Build;

